/**
 * Gemeinsame Festlegungen zu Sitzungen (§24).
 *
 * Enthält ausschließlich Typen und Konstanten, die auch im Browser gefahrlos nutzbar sind
 * (§41.2). Insbesondere steht hier **kein** Cookie-Wert und keine Prüfkennung.
 */
/** Name der Kopfzeile, in der das Frontend den CSRF-Wert sendet (§25.1). */
export const CSRF_HEADER = 'X-CSRF-Token';
/** Pfad der Administratorsitzung in der API (§23.1). */
export const ADMIN_SESSION_PATH = '/api/v1/admin/session';
/** Pfad der Teilnehmersitzung in der API (§23.1). */
export const PARTICIPANT_SESSION_PATH = '/api/v1/participant/session';
/**
 * Pfad der Teilnehmeranmeldung (§9.1, §23.1).
 *
 * Liegt im öffentlichen Bereich, weil vor der Anmeldung naturgemäß keine Sitzung besteht.
 */
export const TEILNEHMER_ANMELDUNG_PATH = '/api/v1/public/teilnehmer/anmeldung';
/** Zustandsauskunft des Teilnehmers — die einzige Quelle der Teilnehmeroberfläche (§19.2). */
export const TEILNEHMER_ZUSTAND_PATH = '/api/v1/participant/zustand';
/** Stimmabgabe (§13). */
export const TEILNEHMER_STIMME_PATH = '/api/v1/participant/stimme';
/** Pfad des Administrationsbereichs in der Oberfläche. */
export const VERWALTUNG_PFAD = '/verwaltung';
//# sourceMappingURL=session.js.map